<template>
    <client-page class="wrap wrap--sub">
        <!-- 서브비주얼 -->
        <sub-visual :visual="'마이페이지'"></sub-visual>
        <mypage-navigation></mypage-navigation>

        <section class="section" v-if="me">
            <v-container>
                <tit-primary sc="edit profile" tit="회원정보수정"> </tit-primary>

                <div class="text-right color-grey page-text--sm mb-20 line-height-1"><span class="primary--text">*</span>필수 입력항목</div>
                <div role="table" class="board-table board-table--input">
                    <div role="rowgroup">
                        <input-row label="아이디">
                            {{ me.username }}
                        </input-row>
                        <!-- 회원유형 -->
                        <myinfo-usertype v-model="me" />

                        <input-row label="비밀번호" pointer>
                            <v-text-field v-model="me.subPassword" type="password" name="" value="" outlined hide-details placeholder="비밀번호를 입력하세요." />
                            <p class="d-block text-grey mt-4 font-size-10 font-size-lg-12">* (영문대소문자/숫자/특수문자 조합, 8 - 16자)</p>
                        </input-row>

                        <input-row label="비밀번호 확인" pointer>
                            <v-text-field v-model="me.subPassword2" type="password" name="" value="" outlined hide-details placeholder="비밀번호를 재입력하세요." />
                        </input-row>

                        <template v-if="isOrganization">
                            <input-row label="기업명" pointer>
                                <v-text-field v-model="me.companyName" type="text" class="input" outlined hide-details />
                            </input-row>
                            <input-row label="대표자명" pointer>
                                <v-text-field v-model="me.ceoName" type="text" class="input" outlined hide-details />
                            </input-row>
                            <input-row label="기업설립일" pointer>
                                <v-text-field v-model="me.establishedAt" type="date" class="input" outlined hide-details />
                            </input-row>
                            <input-row label="사업자등록번호" pointer>
                                <v-text-field v-model="me.businessNumber" type="text" class="input" outlined hide-details />
                            </input-row>
                        </template>

                        <input-row v-if="isIndividual" label="이름" pointer>
                            <v-text-field v-model="me.name" type="text" class="input" outlined hide-details />
                        </input-row>
                        <input-row v-if="isSupporter" label="닉네임" pointer>
                            <v-text-field v-model="me.nickname" type="text" class="input" outlined hide-details />
                        </input-row>

                        <input-row v-if="isIndividual" :label="isSupporter ? '소속/부서' : '학교/학과'" pointer>
                            <v-row>
                                <v-col>
                                    <v-text-field v-model="me.affiliation" type="text" class="input" outlined hide-details />
                                </v-col>
                                <v-col class="pl-0">
                                    <v-text-field v-model="me.department" type="text" class="input" outlined hide-details />
                                </v-col>
                            </v-row>
                        </input-row>

                        <input-row label="연락처" pointer>
                            <v-row align="center" class="row--x-small">
                                <v-col>
                                    <v-select v-model="me.phone1" :items="['010', '011', '016', '017', '019']" outlined hide-details></v-select>
                                </v-col>
                                <v-col cols="auto">-</v-col>
                                <v-col>
                                    <v-text-field v-model="me.phone2" maxlength="4" outlined hide-details @input="me.phone2 = me.phone2.replace(/[^0-9]/g, '')" />
                                </v-col>
                                <v-col cols="auto">-</v-col>
                                <v-col>
                                    <v-text-field v-model="me.phone3" maxlength="4" outlined hide-details @input="me.phone2 = me.phone2.replace(/[^0-9]/g, '')" />
                                </v-col>
                            </v-row>
                            <!-- <div class="form-tel">
                                <v-select v-model="me.phone1" :items="['010', '011', '016', '017', '019']" outlined hide-details></v-select>
                                <span class="text"></span>
                                <v-text-field v-model="me.phone2" maxlength="4" outlined hide-details @input="me.phone2 = me.phone2.replace(/[^0-9]/g, '')" />
                                <span class="text"></span>
                                <v-text-field v-model="me.phone3" maxlength="4" outlined hide-details @input="me.phone2 = me.phone2.replace(/[^0-9]/g, '')" />
                            </div> -->
                        </input-row>

                        <input-row label="이메일" pointer>
                            <v-text-field v-model="me.email" type="text" class="input" outlined hide-details />
                        </input-row>

                        <input-row label="주소" pointer>

                            <v-row class="row--small">
                                <v-col sm="10">
                                    <v-text-field v-model="me.postcode" type="text" readonly placeholder="우편번호" outlined hide-details @click="$refs.daumPostcode.open()" />
                                </v-col>
                                <v-col cols="auto" sm="2">
                                    <v-btn block elevation="0" dark color="grey-dark"
                                    @click="$refs.daumPostcode.open()" class="w-100 h-100 input-btn"><span>검색</span></v-btn>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field v-model="me.address1" type="text" readonly placeholder="기본 주소를 입력해주세요." outlined hide-details @click="$refs.daumPostcode.open()" />
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field v-model="me.address2" type="text" placeholder="상세 주소를 입력해주세요." outlined hide-details />
                                </v-col>
                            </v-row>

                            <!-- <div class="form-address">
                                <div class="form-address__postcode">
                                    <v-text-field v-model="me.postcode" type="text" readonly placeholder="우편번호" outlined hide-details @click="$refs.daumPostcode.open()" />
                                    <button class="button button--primary" @click="$refs.daumPostcode.open()">검색</button>
                                </div>
                                <v-text-field v-model="me.address1" type="text" readonly placeholder="기본 주소를 입력해주세요." outlined hide-details @click="$refs.daumPostcode.open()" />
                                <v-text-field v-model="me.address2" type="text" placeholder="상세 주소를 입력해주세요." outlined hide-details />
                            </div> -->
                        </input-row>
                        <!-- 자문분야 / 관심분야 -->
                        <myinfo-areas v-model="me" :areas="areas" />

                        <template v-if="isOrganization">
                            <input-row label="홈페이지주소">
                                <v-text-field v-model="me.website" type="text" class="input" outlined hide-details />
                            </input-row>
                            <input-row label="담당자정보">
                                <v-row>
                                    <v-col>
                                        <v-text-field v-model="me.workerName" type="text" label="이름" persistent-placeholder class="input" outlined hide-details />
                                    </v-col>
                                    <v-col>
                                        <v-text-field v-model="me.workerTitle" type="text" label="직책" persistent-placeholder class="input" outlined hide-details />
                                    </v-col>
                                </v-row>
                            </input-row>
                            <input-row label="주요생산제품">
                                <v-text-field v-model="me.mainProduct" type="text" class="input rounded-0" outlined hide-details />
                            </input-row>
                            <input-row label="기업개요">
                                <textarea v-model="me.summary" type="text" class="input rounded-0" />
                            </input-row>
                            <input-row label="기업로고">
                                <v-file-input v-model="me.avatar" dense hide-details outlined class="rounded-0" accept="image/*" />
                            </input-row>
                            <form-files title="소개자료" v-model="me.brochures" />
                        </template>
                    </div>
                </div>

                <div class="button-group">
                    <v-btn large outlined rounded color="grey" elevation="0" class="min-w-120px min-w-lg-200px"><span class="color-grey">취소</span></v-btn>
                    <v-btn large rounded color="primary" elevation="0" @click="save" class="min-w-120px min-w-lg-200px"><span>저장</span></v-btn>
                </div>

                <!-- <div class="bottom-button">
                    <button class="button button--border-primary"><span>취소</span></button>
                    <button class="button button--primary" @click="save"><span>저장</span></button>
                </div> -->
            </v-container>
        </section>

        <daum-postcode ref="daumPostcode" @change="({ postcode, address }) => Object.assign(me, { postcode, address1: address })"></daum-postcode>
    </client-page>
</template>

<script>
import api from "@/api";
import CryptoAES from "@/plugins/crypto-aes";
import { INDIVIDUAL_KINDS, USER_TYPES } from "@/assets/variables";

import SubVisual from "@/components/client/sub/sub-visual.vue";
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import InputRow from "@/components/client/dumb/input-row.vue";
import FormFiles from "@/components/client/join/skin/form-files.vue";
import MyinfoAreas from "@/components/client/mypage/myinfo-areas.vue";
import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";
import MyinfoUsertype from "@/components/client/mypage/myinfo-usertype.vue";
import MypageNavigation from "@/components/client/mypage-navigation.vue";
import TitPrimary from "@/components/client/dumb/tit-primary.vue";

export default {
    components: {
        SubVisual,
        ClientPage,
        InputRow,
        FormFiles,
        MyinfoAreas,
        DaumPostcode,
        MyinfoUsertype,
        MypageNavigation,
        TitPrimary,
    },
    data() {
        return {
            me: null,
            areas: [],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            try {
                if (!this.accessToken) {
                    this.$router.push({
                        path: "/login",
                        params: this.$router.params,
                    });
                    return;
                }

                var { user } = await api.v1.me.get();
                var [phone1, phone2, phone3] = (user.phone || "").phoneNumberFormat().split("-");
                const avatar = user?.avatar?.url ? await api.getResource(user.avatar.url, true) : null;
                const brochures = await Promise.all((user?.brochures || [])?.map(async ({ url }) => api.getResource(url, true)));

                this.me = {
                    ...user,
                    phone1,
                    phone2,
                    phone3,
                    avatar,
                    brochures,
                    establishedAt: user.establishedAt?.toDate(),
                };

                var { areas } = await api.v1.areas.gets();
                this.areas = areas;
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },

        checkPassword(password) {
            var checkSpecial = /[~!@#$%^&*()_+|<>?:{}]/;
            var checkEng = /[a-zA-Z]/;
            var checkNum = /[0-9]/;

            if (!checkSpecial.test(password)) throw new Error("비밀번호에 특수문자가 포함되어있어야합니다.");
            if (!checkEng.test(password)) throw new Error("비밀번호에 영문이 포함되어있어야합니다.");
            if (!checkNum.test(password)) throw new Error("비밀번호에 숫자가 포함되어있어야합니다.");
            if (password.length < 8 || 16 < password.length) throw new Error("비밀번호는 8~16자까지입니다.");
        },

        validate() {
            try {
                if ((this.me.subPassword || this.me.subPassword2) && this.me.subPassword != this.me.subPassword2) throw new Error("비밀번호 및 비밀번호확인이 일치하지 않습니다");
                if (this.me.subPassword && this.me.subPassword2) this.checkPassword(this.me.subPassword);

                return true;
            } catch (error) {
                alert(error.message);
            }
            return false;
        },

        async save() {
            if (this.validate()) {
                const _user = this.me._id;

                if (this.me?._avatar) {
                    await api.v1.users.avatar.delete({ _id: this.me._avatar, _user });
                }

                for (const _id of this.me?._brochures || []) {
                    await api.v1.users.brochures.delete({ _id, _user });
                }

                await api.v1.me.put({
                    ...this.me,
                    subPassword: this.me.subPassword ? CryptoAES.encrypt(this.me.subPassword) : undefined,
                    subPassword2: undefined,
                    _brochures: undefined,
                    brochures: undefined,
                });

                if (this.me?.avatar) {
                    await api.v1.users.avatar.post({ _user }, this.me.avatar);
                }

                if (this.me?.brochures?.length) {
                    for (const [index, brochure] of this.me.brochures.entries()) {
                        await api.v1.users.brochures.post({ _user, index }, brochure);
                    }
                }

                alert("수정되었습니다");
                this.$router.go();
            }
        },
    },
    computed: {
        accessToken() {
            return this.$store.state.accessToken;
        },
        phone() {
            return this.phone1 && this.phone2 && this.phone3 ? [this.phone1, this.phone2, this.phone3].join("-") : undefined;
        },
        payload() {
            return this.$store.state.payload || {};
        },
        scope() {
            return this.payload.scope || [];
        },
        isIndividual() {
            return this.me.type == USER_TYPES.INDIVIDUAL;
        },
        isOrganization() {
            return this.me.type == USER_TYPES.ORGANIZATION;
        },
        isSupporter() {
            return this.me.kind == INDIVIDUAL_KINDS.SUPPORTER.value;
        },
    },
    watch: {
        "me.phone1"() {
            var { phone1, phone2, phone3 } = this.me;
            this.me.phone = [phone1, phone2, phone3].join("-");
        },
        "me.phone2"() {
            var { phone1, phone2, phone3 } = this.me;
            this.me.phone = [phone1, phone2, phone3].join("-");
        },
        "me.phone3"() {
            var { phone1, phone2, phone3 } = this.me;
            this.me.phone = [phone1, phone2, phone3].join("-");
        },
    },
};
</script>
